import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";

export const E50_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.e50AboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.e50AwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("enterprise-50"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("enterprise-50"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsGallery("enterprise-50"),
  },
  {
    label: "How to Apply",
    link: RouteFactory.e50NominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.e50ContactUsPage,
  },
  {
    label: "FAQ",
    link: RouteFactory.e50FaqPage,
  },
];

export const E50_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.e50AboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.e50AwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("enterprise-50"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("enterprise-50"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("enterprise-50"),
    enabled: true,
  },
  {
    text: "How to Apply",
    link: RouteFactory.e50NominatePage,
    enabled: true,
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "applicationsTab",
    label: "Applications",
  },
  {
    key: "eligibilityTab",
    label: "Eligibility",
  },
  {
    key: "declarationsTab",
    label: "Declarations",
  },
  {
    key: "rulesTab",
    label: "Rules",
  },
];
